import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import counter1 from './assets/images/counter1.png';
import counter2 from './assets/images/counter2.png';
import reactError from './assets/images/react-error.png';
import counter from './assets/videos/counter.mp4';


const ReactLesson8 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      import React, { useState } from 'react';

      const App = () => {
        const [cunt, setCount] = useState(0);

        return {
          <div>
             <p>count: {count}</p>
             <button onClick={() => setCount(count + 1)}>Increment</button>
             </div>
        };
      }

      export default App;

      `
    );
    const code1 = (
      'text',
      `
      import react, { Component } from 'react';

      class App extends Component {

        constructor(props) {
          super(props);
          this.state = {
              count: 0
          };
        }

        handleClick = () => {
          //updating state with an object
          this.setState({ count: this.state.count + 1});
        };

        render() {
          return (
            <div> 
                <p>count: {this.state.count}</p>
                <button onClick={this.handleClick}>Increment</button>
                </div>
          );
        }
      }

     
      export default App;

      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">




    <div className="alert alert-secondary" role="alert">
    <h3><strong>State Management</strong></h3>
      <p>State management in React refers to the management and manipulation of data within a React application. It involves handling and controlling the state or data that affects a component's rendering, behavior, and UI. Managing state effectively is crucial for building complex and dynamic user interfaces in React.</p>
      <h4 class="text-dark">useState() Hook</h4>
      <p>React components can have their own local state managed using the useState hook for functional components. States usually have default values and they saved in containers called state variables.</p>
      <p class="mb-4">To demonstrate this we are going to create a function called <strong>counter()</strong>, which will be assinged a value that increases when we click on the button. We will do ths using both <strong>Class</strong> and <strong>Function</strong> components.</p>
      <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />           <h4 class="text-dark">Explanation</h4>
      <p>To set state in a functional component, we have to first import <strong>useState</strong> from React as follows</p>
      <strong><pre>import React, { useState } from 'react';</pre></strong>
      <p class="mb-2">If we attempt to use it without the import statement, we get the following error:</p>
      <img class="img-fluid mb-4" src={reactError} alt="react" />
      <p>Next, we set the React hooks as follows:</p>
      <strong><pre>const [count, setCount] = useState(0);</pre></strong>
      <p>We can refer to count as a state variable, which as you can see has an initial value of 0. Whenever we want to update the value we just use hook a value to it as follows:</p>
      <strong><pre>setCount(value)</pre></strong>
      <p>This will immediately update the initial 0 value to the specified one. And we can also do this for booleans as well.</p>
      <strong><pre>const [loading, setLoading] = useState(false);</pre></strong>
      <strong><pre>setLoading(false);</pre></strong>
      <h4 class="text-dark mt-4">Result:</h4>
      <video controls className="mb-4" style={{width: '550px', height: '360px'}}>
      <source src={counter} type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
      <p>Now, let's see how we can do the same with class components.</p>
      <h4 class="text-dark">setState() (Class Components)</h4>
      <p>In React class components, <strong>setState()</strong> is a method used to update the component's local state. It is the primary way to update the state of a component and triggers a re-render of the component and its children to reflect the updated state in the UI.</p>
      <h4 class="text-dark">Syntax of setState() in Class Components:</h4>
      <p>In a class-based React component, you call setState() by passing an object containing the new state or a function that returns the new state based on the previous state.</p>
      <p>Let's re-enact the counter task with class components. </p>
      <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />           <h4 class="text-dark">Explanation</h4>
      <p>To create a state variable, we have to create a constructor function and set the variable there as follows:</p>
      <strong>
          <pre>
       constructor(props) 
       super('props')
       this.'state =' {
         'count: 0'
       };
    
        </pre>
      </strong>
      <p>And we get the same result:</p>
      <h4 class="text-dark mt-4">Result:</h4>
      <video controls className="mb-4" style={{ width: '500px', height: '300px' }}>
      <source src={counter} type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
      <p>Here, we have a state variable called <strong>count</strong> and it has an initial value of <strong>0</strong></p>
      <p>To update the state we have to call <strong>setState</strong> and assign a new value to the state variable:</p>
      <strong><pre>this.setState({ 'count: this.state.count + 1' });</pre></strong>
      <p>State variables can also be <strong>booleans, objects or arrays</strong>.</p>
      <p>It is also important to understand that state updates are not synchronous. Do not rely on the immediate state value after calling <strong>setState()</strong> as it may not reflect the updated state in the same lifecycle method.</p>
      
      <h4><strong>Summary</strong></h4>
      <p><strong>useState</strong> is a fundamental React hook that brings state management capabilities to functional components, enabling them to manage local state and update the UI based on state changes.</p>
      <p><strong>setState()</strong> is a fundamental method in class-based React components for managing and updating local state, triggering re-renders, and ensuring that the UI reflects the most current state data.</p>
  
   </div>

      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson8
  